import { CheckIcon } from "@heroicons/react/24/solid";
import { classNames } from "../utils/formatters";

export default function VerifiedUserPerks({
  idVerified,
}: {
  idVerified: boolean;
}) {
  return (
    <ul
      role="list"
      className={classNames(" mt-3 ", !idVerified ? "list-disc pl-6" : "")}
    >
      <li
        className={
          idVerified ? "flex space-x-3 text-gray-500" : "text-gray-500"
        }
      >
        {idVerified ? (
          <CheckIcon
            className="flex-shrink-0 h-5 w-5 text-green-500"
            aria-hidden="true"
          />
        ) : null}
        <span className="text-sm ">
          Tus publicaciones tendrán mayor visibilidad y generarán mayor
          confianza entre las personas interesadas.
        </span>
      </li>
      <li
        className={
          idVerified ? "flex space-x-3 text-gray-500" : "text-gray-500"
        }
      >
        {idVerified ? (
          <CheckIcon
            className="flex-shrink-0 h-5 w-5 text-green-500"
            aria-hidden="true"
          />
        ) : null}
        <span className="text-sm ">
          Tendrás mayor credibilidad como vendedor.
        </span>
      </li>
      <li
        className={
          idVerified ? "flex space-x-3 text-gray-500" : "text-gray-500"
        }
      >
        {idVerified ? (
          <CheckIcon
            className="flex-shrink-0 h-5 w-5 text-green-500"
            aria-hidden="true"
          />
        ) : null}
        <span className="text-sm ">
          Los usuarios verificados ayudan a reducir estafas y a crear un
          ambiente más seguro para vendedores y compradores.
        </span>
      </li>
    </ul>
  );
}
